import { Download } from "lucide-react";
import { downloadUrl, downloadLabel } from "@/lib/resources";

export const EpisodeResources = ({ ep, resources }) => {
  const items = (resources || []).filter((r) => r.episode_id && r.episode_id === ep.id);
  if (!items.length) return null;
  return (
    <div data-testid={`episode-resources-${ep.id}`} className="mt-5 flex flex-col gap-2">
      {items.map((r) => (
        <a key={r.id} href={downloadUrl(r.id)} download={r.file_name} data-testid={`episode-resource-${ep.id}-${r.id}`} title={r.title}
          className="inline-flex items-center gap-2 self-start border border-mp-orange/60 text-mp-orange hover:bg-mp-orange hover:text-mp-black transition-colors duration-300 px-4 py-2 text-[11px] font-display tracking-[0.24em] uppercase">
          <Download size={13} /> {downloadLabel(r)} · {r.title.split(" — ")[0]}
        </a>
      ))}
    </div>
  );
};

export default EpisodeResources;
